var classes = {"checkboxContainer":"xQrET","checkboxInput":"_0FmnM","checkboxInner":"qhpmx","checkboxLabelWrapper":"WWTn2","checkboxLabel":"eDKHW","checkboxIcon":"GJS7K","checkboxWrapper":"_48FCt"};

export { classes as default };
